import React from 'react';
import {StyledSocialIcon, StyledSocialIconLink} from './SocialIcon.style';

function SocialIcon({ iconName, iconUrl, iconColor }) {
  return (
    <StyledSocialIconLink href={iconUrl} target="blank">
      <StyledSocialIcon color={iconColor}>
        <i className={iconName} aria-hidden="true" />
      </StyledSocialIcon>
    </StyledSocialIconLink>
  );
}

export default SocialIcon;
